import {
  Autocomplete,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Box
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { apiClient, ADMIN_SERVER_BASE_URL } from "../util/apiClient";
import { LoadingButton } from "@mui/lab";
import LoginIcon from "@mui/icons-material/Login";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../store";
import { string } from "prop-types";
import { errorNotify } from "../util/functions";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { FormControl } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { setUserLoggedIn } from "../store/appSlice";
import { setUserConnected } from "../store/userSlice";



export interface IAddRapport {
  setPlanToCreate: any;
  planToCreate: any;
}

export interface IUser {
  userId: number | null;
  userName: string;
  userSurname: string;
}

export interface IUserInfos {
  user: IUser;
  password: string;
}

export default function Login() {
  //props


  //Redux
  const dispatch = useDispatch()

  //Hooks
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [values, setValues] = React.useState({
    showPassword: false,
  });


  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };





  const handleLogin = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true)
      const apiPayload = {
        nomUtilisateur: login,
        motDePasseInitial: password
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL, "/tablesystem/connection", apiPayload);
      if (res.status === 1) {
        dispatch(setUserConnected(res.data))
        dispatch(setUserLoggedIn(true))
      } else {
        console.log("status !==1");
        errorNotify("Idtentifiants incorrects");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:73 ~ handleLogin ~ error:", error)
      errorNotify("Une erreur est survenue");
    } finally {
      setLoading(false)
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh", background: "#444654" }}
      >
        <Grid
          container
          component="form"
          spacing={2}
          style={{
            background: "#fff",
            padding: 20,
            margin: 10,
            marginTop: -50,
            borderRadius: 10,
            width: mdDown ? "100%" : "30%",
          }}
        >
          <Grid item md={12} xs={12} sm={12}>
            <Typography style={{ color: "grayText" }}>SPIDER-ADMIN</Typography>{" "}
          </Grid>
          <Grid item md={12} xs={12} sm={12}>
            <TextField
              fullWidth
              size="medium"
              label="Login"
              value={login}
              onChange={(e: any) => setLogin(e.target.value)}
            />
          </Grid>

          <Grid item md={12} xs={12} sm={12}>
            <FormControl sx={{ width: "100%" }} variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                Mot de passe
              </InputLabel>
              <OutlinedInput
                size="medium"
                id="outlined-adornment-password"
                type={values.showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={(e: any) => setPassword(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Mot de passe"
              />
            </FormControl>

          </Grid>
          <Grid item md={12} xs={12} sm={12}>
            <LoadingButton
              type="submit"
              style={{ width: "100%", background: "#17365d" }}
              variant="contained"
              loadingPosition="end"
              size="medium"
              loading={loading}
              endIcon={<LoginIcon />}
              onClick={handleLogin}
            >
              Connecter
            </LoadingButton>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
